import { render, staticRenderFns } from "./FooterDesktop.vue?vue&type=template&id=b14b2270&scoped=true"
import script from "./FooterDesktop.vue?vue&type=script&lang=js"
export * from "./FooterDesktop.vue?vue&type=script&lang=js"
import style0 from "./FooterDesktop.vue?vue&type=style&index=0&id=b14b2270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14b2270",
  null
  
)

export default component.exports